import dayjs from "dayjs";
import { PayloadAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  TransferRead,
  TransferService,
  TransferQueryParams,
  TransferCategory,
} from "@/domains/transfer";
import { RootState } from "@/stores";
import { DateRange } from "@/domains/common";

interface TenantSelfWithdrawState {
  loading: boolean;
  dateRange: DateRange;
  queryParams: TransferQueryParams;
  transfers: TransferRead[];
}

const initialState: TenantSelfWithdrawState = {
  loading: false,
  dateRange: DateRange.day0,
  queryParams: {
    created_started_at: dayjs().startOf("day").toISOString(),
    created_stopped_at: dayjs().endOf("day").toISOString(),
  },
  transfers: [],
};

export const tenantSelfWithdrawSelects = {
  loading: (state: RootState) => state.tenantSelfWithdraw.loading,
  dateRange: (state: RootState) => state.tenantSelfWithdraw.dateRange,
  queryParams: (state: RootState) => state.tenantSelfWithdraw.queryParams,
  transfers: (state: RootState) => state.tenantSelfWithdraw.transfers,
};

export const tenantSelfWithdrawThunks = {
  list: createAsyncThunk(
    "tenantSelfWithdraw/list",
    async (params: TransferQueryParams = {}) => {
      const res = await TransferService.list({
        ...params,
        category: TransferCategory.TenantWithdraw,
      }).run();

      return res.data.msg;
    }
  ),
};

export const tenantSelfWithdrawSlice = createSlice({
  name: "tenantSelfWithdraw",
  initialState,
  reducers: {
    setQueryParams: (state, action: PayloadAction<TransferQueryParams>) => {
      state.queryParams = action.payload;
    },
    setDateRange: (state, action: PayloadAction<DateRange>) => {
      state.dateRange = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(tenantSelfWithdrawThunks.list.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(
      tenantSelfWithdrawThunks.list.fulfilled,
      (state, action) => {
        state.loading = false;
        state.transfers = action.payload.transfers;
      }
    );
    builder.addCase(tenantSelfWithdrawThunks.list.rejected, (state) => {
      state.loading = false;
      state.transfers = [];
    });
  },
});

export const tenantSelfWithdrawActions = tenantSelfWithdrawSlice.actions;
